// extracted by mini-css-extract-plugin
module.exports = {"isSaved":"_1Z1fC___AddToSavedItemsButton-module__isSaved"};